package com.nonopn.skydome.common.app.pages.main.model.api

import com.nonopn.skydome.common.app.pages.certificates.ThunderDetectionActivityWithIncidence
import kotlinx.serialization.Serializable

@Serializable
data class ApiAnswerProjectWithThunderActivities(
    val project: Project,
    val activities: List<ThunderDetectionActivityWithIncidence>,
)
